/**
 * [获取业务类枚举数据]
 * @author: Fu Xiaochun
 * @date: 2021-12-23 
 */
import { getEnum } from '@/apis/common';
import { message } from 'antd';

const getEnumData = (enumName, cb)=>{
    getEnum({enumName}).then(res=>{
        cb && cb(res.result);
    }).catch(err=>{
        message.error(err.message);
    });
};

export default getEnumData;